class BymsSizeGuide extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-size-guide-open]');
    this.dialog = this.querySelector('[data-size-guide-dialog]');
    this.closeButton = this.querySelector('[data-size-guide-close]');

    if (!this.trigger || !(this.dialog instanceof HTMLDialogElement)) return;

    this.handleOpen = () => this.dialog.showModal();
    this.handleClose = () => this.dialog.close();
    this.handleBackdropClick = (event) => {
      if (event.target === this.dialog) this.dialog.close();
    };
    this.handleDialogClose = () => this.trigger.focus({ preventScroll: true });

    this.trigger.addEventListener('click', this.handleOpen);
    this.closeButton?.addEventListener('click', this.handleClose);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.handleDialogClose);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleOpen);
    this.closeButton?.removeEventListener('click', this.handleClose);
    this.dialog?.removeEventListener('click', this.handleBackdropClick);
    this.dialog?.removeEventListener('close', this.handleDialogClose);
  }
}

if (!customElements.get('byms-size-guide')) {
  customElements.define('byms-size-guide', BymsSizeGuide);
}
